var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSyncLOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 8.66675V2.16675L17.3333 10.8334L26 19.5001V13.0001C33.1717 13.0001 39 18.8284 39 26.0001C39 28.1884 38.4583 30.2684 37.4833 32.0667L40.6467 35.2301C42.3367 32.5651 43.3333 29.4017 43.3333 26.0001C43.3333 16.4234 35.5767 8.66675 26 8.66675ZM26 39.0001C18.8283 39.0001 13 33.1717 13 26.0001C13 23.8117 13.5417 21.7317 14.5167 19.9334L11.3533 16.7701C9.66332 19.4351 8.66666 22.5984 8.66666 26.0001C8.66666 35.5767 16.4233 43.3334 26 43.3334V49.8334L34.6667 41.1667L26 32.5001V39.0001Z",
    fill: "#F25C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyncLOrange);
export default __webpack_public_path__ + "static/media/icon-sync-l-orange.9921f9449aca19e0546a0d19fd1ec7e0.svg";
export { ForwardRef as ReactComponent };